"use client";

import { useSearchParams } from "next/navigation";
import { ContactForm } from "@/components/contact/ContactForm";
import { contactTopics } from "@/lib/contact-schema";

/**
 * Liest Thema und Anlass aus der Adresse und belegt das Formular damit vor –
 * etwa `/kontakt?thema=nis2&anlass=…` aus einer Landingpage oder dem
 * Betroffenheitscheck. Aus einer Anzeige heraus fehlen dann nur noch die
 * Kontaktdaten; jeder gesparte Schritt ist messbar mehr Anfragen.
 *
 * Eigene Komponente, weil `useSearchParams` auf einer statisch vorgerenderten
 * Seite eine Suspense-Grenze verlangt (sonst bricht der Build). Die Seite
 * rendert als Rückfall das normale Formular – das HTML bleibt vollständig.
 *
 * Nur bekannte Themen werden übernommen, der Anlass ist gekürzt. Aus der
 * Adresse kommt beliebiger Text; React maskiert ihn, trotzdem gehört er nicht
 * ungeprüft in ein Formular.
 */
export function ContactFormFromParams() {
  const params = useSearchParams();
  const thema = params.get("thema") ?? "";
  const anlass = (params.get("anlass") ?? "").slice(0, 300);
  const topic = contactTopics.some((t) => t.value === thema) ? thema : "";

  return (
    <ContactForm
      key={`${topic}|${anlass}`}
      initialTopic={topic}
      initialMessage={anlass ? `${anlass}\n\n` : ""}
    />
  );
}
